import type { BaseLayoutSpec } from '@tunasong/plugin-lib'
import {
  ListItemIcon,
  ListItemText,
  MenuRadioGroup,
  MenuRadioItem,
  Submenu,
  SubmenuContent,
  SubmenuTrigger,
} from '@tunasong/ui-lib'
import type { FC } from 'react'

export interface LayoutSubmenuProps {
  layouts: BaseLayoutSpec[]
  selected?: BaseLayoutSpec
  onChange(layout: BaseLayoutSpec): void
}

/** The header's layout selector as an overflow-menu row: "Layout" opens a radio list, the current layout checked */
export const LayoutSubmenu: FC<LayoutSubmenuProps> = props => {
  const { layouts, selected, onChange } = props
  const SelectedIcon = selected?.Icon

  const handleValueChange = (name: unknown) => {
    const layout = layouts.find(l => l.name === name)
    if (layout) {
      onChange(layout)
    }
  }

  return (
    <Submenu>
      <SubmenuTrigger>
        {SelectedIcon ? (
          <ListItemIcon>
            <SelectedIcon />
          </ListItemIcon>
        ) : null}
        <ListItemText primary="Layout" />
      </SubmenuTrigger>
      <SubmenuContent>
        <MenuRadioGroup value={selected?.name} onValueChange={handleValueChange}>
          {layouts.map(layout => (
            // Switching layout is a single choice, so the menu closes (radio items stay open by default)
            <MenuRadioItem key={layout.name} value={layout.name} closeOnClick>
              {layout.name}
            </MenuRadioItem>
          ))}
        </MenuRadioGroup>
      </SubmenuContent>
    </Submenu>
  )
}
